import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignSelf:'center',
    paddingHorizontal: 16,
  },
  item: {
    maxWidth: 400,
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 4,
    flexDirection: "row",
    justifyContent: "center",
    paddingVertical: 12,
    paddingHorizontal: 12,
    shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 4,
        },
        shadowOpacity: 0.25,
        shadowRadius: 6,
        elevation: 4,
  },
  icon: {
    width: 27,
    height: 'auto',
    /* marginTop: 6,
    marginRight: 12, */
  },
  content: {
    flex: 1,
  },
  title: {
    textAlign: 'center',
    fontSize: 21,
    fontWeight: "bold",
    color: "#077A97",
  },
  description: {
    fontSize: 14,
    color: "#939394",
    marginTop: 10,
  },
});
